export default {
  button: {
    addCustomField: 'Add custom field',
    addField: 'Add field',
    add: 'Add',
    addLink: 'Add link',
    copy: 'Copy',
    copyAsHTML: 'Copy as HTML',
    copyAsSelect: 'Copy signature for outlook',
    delete: 'Delete',
    download: 'Download',
    importProject: 'Import project',
    load: 'Load',
    newProject: 'New project',
    showSetup: 'Show setup instruction',
    uploadImage: 'Upload image',
    viewSource: 'View source',
    remove: 'Remove',
    close: 'Close',
    ok: 'OK',
    cancel: 'Cancel'
  },
  form: {
    label: 'Label',
    noLabel: 'No label',
    type: 'Type',
    value: 'Value'
  },
  table: {
    name: 'Name',
    actions: 'Actions'
  },
  message: {
    warning: 'Warning',
    deleteConfirm: 'This will permanently delete the file. Continue?'
  }
};
